import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  name: null,
  lastname: null,
  userPic: null,
  userName: null,
  userRole: 0,
  user_id: 0,
  worker_number: null,
  email: null,
  birth_date: null,
  area: null,
  sex: null,
  is_consent: 0,
  userPicBase64: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserData: (state, action) => {
      const data = action.payload || {};
      for (const key in data) {
        if (Object.hasOwnProperty.call(data, key)) {
          state[key] = data[key];
        }
      }
    },
    clearUserData: state => {
      return initialState; // Resetando os dados do usuário
    },
  },
});

export const {setUserData, clearUserData} = userSlice.actions;
export default userSlice.reducer;
